enum AllianceClass {
    None = "none",
    Warriors = "warriors",
    Traders = "traders",
    Researchers = "researchers"
}

function AllianceClassFromID(id: number): AllianceClass {
    switch (id) {
        case 1:
            return AllianceClass.Warriors
        case 2:
            return AllianceClass.Traders
        case 3:
            return AllianceClass.Researchers
        default:
            return AllianceClass.None
    }
}

enum CharacterClass {
    None = "none",
    Collector = "collector",
    General = "general",
    Discoverer = "discoverer"
}

function CharacterClassFromID(id: number): CharacterClass {
    switch (id) {
        case 1:
            return CharacterClass.Collector
        case 2:
            return CharacterClass.General
        case 3:
            return CharacterClass.Discoverer
        default:
            return CharacterClass.None
    }
}

export {
    AllianceClassFromID,
    AllianceClass,
    CharacterClassFromID,
    CharacterClass,
}